var exports = {
  "kL": "ChannelDivider.module__container___NHpXMk",
  "JW": "ChannelDivider.module__unreadContainer___NHpXMk",
  "iN": "ChannelDivider.module__unreadDate___NHpXMk",
  "n8": "ChannelDivider.module__line___NHpXMk",
  "Qq": "ChannelDivider.module__text___NHpXMk",
  "KQ": "ChannelDivider.module__unreadLine___NHpXMk",
  "vD": "ChannelDivider.module__dateWithUnreadText___NHpXMk",
  "HN": "ChannelDivider.module__unreadBadge___NHpXMk",
};

module.exports = exports;
